import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';

const DEFAULT_DESCRIPTION = 'Не удалось перейти к оплате. Пожалуйста, попробуйте ещё раз';

type OrderSubmissionErrorModalProps = AlertProps & {
    onSubmit: () => Promise<unknown>;
    errorDescription?: string;
};

export const OrderSubmissionError = (props: OrderSubmissionErrorModalProps) => {
    const { onSubmit, errorDescription, ...other } = props;

    return (
        <Alert
            {...other}
            title="Что-то пошло не так"
            description={errorDescription ? errorDescription : DEFAULT_DESCRIPTION}
            button={
                <DrawerBottomFixed>
                    <DrawerButton onClick={onSubmit}>Попробовать еще раз</DrawerButton>
                </DrawerBottomFixed>
            }
        />
    );
};
